export const component = {
    module:'user',
    moduleShow:'Profile'
}